import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import logo from "./Media/focus logo.png";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { LanguageOutlined, MenuOutlined } from "@mui/icons-material";
import { useState } from "react";

const drawerWidth = 240;

function Navbar(props) {
  const { i18n } = useTranslation();
  const { t } = useTranslation();
  const [isMenuToggled, setIsMenuToggled] = useState(false);

  const navItems = [
    t("About"),
    t("Our Projects"),
    t("Business Cooperation"),
    t("Contact Us"),
  ];

  const drawerWidth = 240;
  const { window } = props;

  const handleDrawerToggle = () => {
    setIsMenuToggled((prevState) => !prevState);
  };

  const handleCloseNavMenu = (e, i) => {
    const sectionElement = document.getElementById(i);
    if (sectionElement) {
      sectionElement.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const changeLanguage = () => {
    const currentLanguage = i18n.language;
    const newLanguage = currentLanguage === "en" ? "ar" : "en";
    i18n.changeLanguage(newLanguage);
  };

  const lang = Cookies.get("i18next");
  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: "center" }}>
      <Typography
        sx={{ my: 2, color: "#000", fontWeight: "bold", fontSize: "18px" }}
      >
        Focus Trading Company
      </Typography>
      <Divider />
      <List>
        {navItems.map((item, i) => (
          <ListItem key={item} disablePadding>
            <ListItemButton
              sx={{ textAlign: "center" }}
              onClick={(e) => {
                handleCloseNavMenu(e, item);
              }}
            >
              <ListItemText primary={item} />
            </ListItemButton>
          </ListItem>
        ))}
        {/*     <ListItem disablePadding>
          <ListItemButton
            sx={{ textAlign: "center" }}
            onClick={() => navigate("/ramadanSchedule")}
          >
            <ListItemText
              primary={
                <Typography
                  variant="body1"
                  sx={{
                    fontFamily: "Arial, sans-serif",
                    fontWeight: "bold",
                    fontSize: "1.1rem",
                    color: "#000",
                    textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
                    letterSpacing: "2px",
                  }}
                >
                  {`${t("Ramadan Schedule")}`}
                </Typography>
              }
            />
          </ListItemButton>
        </ListItem>
            */}
        <ListItem disablePadding sx={{ justifyContent: "center" }}>
          <IconButton onClick={changeLanguage} sx={{ color: "#707070" }}>
            <LanguageOutlined sx={{ color: "#707070" }} />
          </IconButton>
        </ListItem>
      </List>
    </Box>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;
  const navigate = useNavigate();

  return (
    <Box sx={{ display: "flex" }}>
      <AppBar
        component="nav"
        sx={{
          position: "absolute",
          top: "10px",
          bgcolor: "#D8D8D842",
          borderRadius: "20px",
        }}
      >
        <Toolbar>
          <Typography
            component="a"
            href="/"
            sx={{ flexGrow: 1, display: { xs: "block", sm: "block" } }}
          >
            <img
              alt="logo"
              src={logo}
              style={{
                width: "150px",
                height: "50px",
                objectFit: "cover",
                marginTop: "12px",
              }}
            />
          </Typography>
          <Box
            sx={{
              display: { md: "none" },
            }}
          >
            <IconButton>
              <MenuOutlined
                sx={{ color: "#fff" }}
                onClick={handleDrawerToggle}
              />
            </IconButton>
          </Box>

          <Box sx={{ display: { xs: "none", md: "block" } }}>
            {/*  <Button
              sx={{
                fontFamily: "Arial, sans-serif",
                fontWeight: "bold",
                fontSize: "1.1rem",
                textShadow: "0px 0px 10px rgba(255, 255, 255, 0.8)",
                letterSpacing: "2px",
                color: "#fff",
              }}
              onClick={() => navigate("/ramadanSchedule")}
            >
              {t("Ramadan Schedule")}
            </Button> */}
            {navItems.map((item, i) => (
              <Button
                key={item}
                onClick={(e) => {
                  handleCloseNavMenu(e, item);
                }}
                sx={{ color: "#fff", fontFamily: "Sitka Text" }}
              >
                {item}
              </Button>
            ))}
          </Box>
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <ListItem sx={{ display: { xs: "none", md: "block" } }}>
              <IconButton onClick={changeLanguage} sx={{ color: "#707070" }}>
                <LanguageOutlined sx={{ color: "white" }} />
              </IconButton>
            </ListItem>
          </Box>
        </Toolbar>
      </AppBar>
      <nav>
        <Drawer
          container={container}
          anchor="right"
          variant="temporary"
          open={isMenuToggled}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: "block", md: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
      </nav>
    </Box>
  );
}

export default Navbar;
